import { all, takeEvery, put, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { flow } from '../modules/flow';
import { types, actions } from '../modules/enderecos';
import enderecoService from '../../commons/services/enderecos';

export default function* enderecoSaga() {
	yield takeEvery(types.CONSULTAR_CEP, consultarCep);
	yield takeEvery(types.CONSULTAR_ESTADO, consultarEstado);
	yield takeEvery(types.CONSULTAR_MUNICIPIO, consultarMunicipio);
}

function* consultarCep(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => enderecoService.consultarCep(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
			if (data.sigla_uf) {
				const [lista_municipios] = yield all([
					call(() =>
						enderecoService.consultarMunicipio({
							codigo_ibge: '',
							nome: '',
							sigla_uf: data.sigla_uf
						})
					),
					call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
				]);
				yield put(actions.updateStore({ municipios: lista_municipios.dados }));
				yield put(actions.updateStore({ dadosConsultaCep: data }));
			} else {
				yield put(actions.updateStore({ municipios: [] }));
				yield put(
					actions.updateStore({
						dadosConsultaCep: {
							sigla_uf: null,
							cod_ibge_municipio: null,
							bairro: null,
							logradouro: null
						}
					})
				);
			}
		}
	});
}

function* consultarEstado(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => enderecoService.consultarEstado(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
			yield put(actions.updateStore({ estados: data.dados }));
		}
	});
}

function* consultarMunicipio(action) {
	yield* flow({
		type: action.type,
		fnTry: function*() {
			const [data] = yield all([
				call(() => enderecoService.consultarMunicipio(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
			yield put(actions.updateStore({ municipios: data.dados }));
		}
	});
}
